export default __webpack_public_path__ + "static/media/Barlow-Thin.ed7c51ae.ttf";